/** Checkout pseudo-method for shop FlexxiPlan deposit (not a standard order checkout). */
export const PAYMENT_METHOD_FLEXXI = "FLEXXI";

/** Customer-facing payment method order — manual bank transfer first. */
const PAYMENT_METHOD_ORDER = ["BANK_IN", "GKASH", PAYMENT_METHOD_FLEXXI, "CREDITS", "STRIPE"] as const;

export function sortPaymentMethods(methods: string[]): string[] {
  return [...methods].sort(
    (a, b) => PAYMENT_METHOD_ORDER.indexOf(a as (typeof PAYMENT_METHOD_ORDER)[number]) -
      PAYMENT_METHOD_ORDER.indexOf(b as (typeof PAYMENT_METHOD_ORDER)[number]),
  );
}

export function paymentMethodLabel(
  method: string,
  opts?: { walletBalance?: number; creditConversionRate?: number; creditCost?: number },
): string {
  switch (method) {
    case "STRIPE":
      return "Card (Stripe)";
    case "GKASH":
      return "Gkash · FPX / eWallet";
    case "BANK_IN":
      return "Manual bank transfer";
    case "CREDITS":
      return opts?.walletBalance != null
        ? `Credits · balance ${opts.walletBalance} cr`
        : "Credits";
    case PAYMENT_METHOD_FLEXXI:
      return "FlexxiPlan · instalments";
    default:
      return method;
  }
}

export function primaryPayButtonLabel(method: string, amountLabel: string): string {
  if (method === "BANK_IN") return "Continue to bank transfer";
  return `Pay · ${amountLabel}`;
}
